import * as React from 'react';
import { PinCard } from './PinCard';
import styles from './Pins.module.css';
import { DigitalMapPin } from 'models/digitalMap';
import { useSelector } from 'react-redux';
import { selectDigitalMap } from 'ducks/universal/digitalMap';

interface Props {
  pinKeys: string[];
  onCloseChat: () => void;
}
export const Pins = React.forwardRef<HTMLDivElement, Props>(({ pinKeys, onCloseChat }, ref) => {
  const digitalMap = useSelector(selectDigitalMap);

  const pins = pinKeys
    .map((pinKey) => digitalMap?.pins.find((p) => p.key === pinKey))
    .filter((pin): pin is DigitalMapPin => pin !== undefined);

  return (
    <div className={styles['container']} ref={ref}>
      <main className={styles['cards']}>
        <div
          className={styles['carousel']}
          style={{ justifyContent: pins.length > 1 ? 'flex-start' : 'center' }}
        >
          {pins.map((pin) => (
            <PinCard pin={pin} key={pin.key} onCloseChat={onCloseChat} />
          ))}
        </div>
      </main>
    </div>
  );
});
